import { VerifyAccount } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router/src/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/verify-account/$verificationCode'].update({
        staticData: { title: { page: 'Title.VerifyAccount' } },
        component: VerifyAccount
    });
};
